export default __webpack_public_path__ + "static/media/CAP_National_Commander's_Unit_Citation_Award.e0935f7d.jpg";